import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: 'alpha-1',
    })
  ],
  state: {
    theme: 'green',
    themes: {
      green: {
        bg1: "white",
        bg2: "#F5F5F5",
        bg3: "#E6E6E6",
        bg4: "#969696",
        fg1: "#284264",
        ac1: "#65C8B0",
        ac1c: "white",
      },
      indigo: {
        bg1:"black",
        bg2:"#141414",
        bg3:"#323232",
        bg4:"#646464",
        fg1:"#969696",
        ac1:"#562CAE",
        ac1c:"white",
      },
    },

    photo: null,

    records: [

    ],
  },
  mutations: {
    toggleTheme(state){
      state.theme = state.theme == 'green' ? 'indigo' : 'green'  
    },
    setPhoto(state, photo){
      state.photo = photo
    },
    saveRecord(state, record){
      state.records.push(record)
    },
    updateRecordName(state, {id, name}){
      Vue.set(state.records.find(r => r.id == id), 'name', name)
    },
  },
  actions: {
  },
  modules: {
  }
})
